<template>
    <div v-if="contents.length">
        <em>{{ processName(valueName) }}</em>
        <span>
        <table class="table table-striped">
            <thead>
            <tr>
                <th scope="col">
                    Value
                </th>
                <th scope="col">
                    Meaning
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="elem in contents" :key="elem.order">
                <td>
                    {{ elem.value }}
                </td>
                <td>
                    {{ elem.meaning }}
                </td>
            </tr>
            </tbody>
        </table>
        </span>
    </div>
</template>

<script>
export default {
    name: "AbstractValueRepresentation",
    props: {
        valueName: {
            type: String,
            default: 'Abstract Values'
        },
        contents: {
            type: Array,
            required: true,
        },
    },
    methods: {
        processName: (name) => {
            if (name === 'permissiblevalue_set') {
                return 'Permissible Values'
            }
            if (name === 'supplementaryvalue_set') {
                return 'Supplementary Values'
            }
            return name
        },
    }
}
</script>

<style scoped>
tr td{
  padding: 0 !important;
  margin: 0 !important;
}
</style>
